/** Angular */
import { Injectable } from '@angular/core';
/** Rxjs */
import { Observable } from 'rxjs';
/** Models */
import { DsChartsPinStatistics } from '../classes/ds-charts-pin-statistics.class';
/** Services */
import { BydRhsAbstractService } from '../../../shared/services/byd-rhs-abstract.service';
/** Sixense */
import { BydGenerateParams } from '@sixense/byd-core-service';
import { DsChartsPinStatisticsInterface } from '../interfaces/ds-charts-pin-statistics.interface';
import { Params } from '@angular/router';
import { DsPinsFilters } from '../../ds-pins/models/ds-pins-filters';

@Injectable({
  providedIn: 'root',
})
export class DsChartsPinsService extends BydRhsAbstractService {
  /**
   * Implement inherited abstract member 'path' from BydRhsAbstractService
   */
  public path: string;

  /**
   * Get pins history for a given period.
   *
   * @param projectId Current project id
   * @param queryParams Params
   * @returns Observable<DsChartsPinStatistics>
   */
  public getStatistics(projectId: number, queryParams: Params): Observable<DsChartsPinStatistics> {
    this.path = `/v1/dspin/projects/${projectId}/pins/statistics`;
    const params = BydGenerateParams<DsPinsFilters>(queryParams);
    return this.get<DsChartsPinStatistics>({ params });
  }

  /**
   * Create DsChartsPinStatistics instance.
   *
   * @param  jsonObject The flat json object.
   * @returns an `DsChartsPinStatistics` instance.
   */
  public createNewInstance(jsonObject: DsChartsPinStatisticsInterface): DsChartsPinStatistics {
    return new DsChartsPinStatistics(jsonObject);
  }
}
